"use client";

import type { Fieldset as FieldsetPrimitive } from "@base-ui/react/fieldset";
import { cva } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import { BaseFieldset, BaseFieldsetLegend } from "./fieldset";
import type { FieldsetParts } from ".";

const conEdisonFieldsetVariants = cva({});

export default function ConEdisonFieldset({
  className,
  ...props
}: FieldsetPrimitive.Root.Props) {
  return (
    <BaseFieldset
      {...props}
      className={cn(
        conEdisonFieldsetVariants({
          className,
        }),
        className,
      )}
    />
  );
}

export const conEdisonFieldsetKit: FieldsetParts = {
  Root: ConEdisonFieldset,
  Legend: BaseFieldsetLegend,
};
